import React from "react";

const BootstrapIconsInner = () => {
  return (
    <section className='section'>
      <p>
        Use the following pattern to add the Bootstrap icons to anywhere in your
        project.
        <code>
          &lt;i class="bi <strong>alarm-fille</strong>"&gt;&lt;/i&gt;
        </code>{" "}
        Replace the bold part with the below icon names. Check the{" "}
        <a href='https://icons.getbootstrap.com/' target='_blank'>
          Official website
        </a>{" "}
        for more info.
      </p>
      <div className='iconslist'>
        <div className='icon'>
          <i className='bi bi-alarm-fill' />
          <div className='label'>alarm-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-alarm' />
          <div className='label'>alarm</div>
        </div>
        <div className='icon'>
          <i className='bi bi-align-bottom' />
          <div className='label'>align-bottom</div>
        </div>
        <div className='icon'>
          <i className='bi bi-align-center' />
          <div className='label'>align-center</div>
        </div>
        <div className='icon'>
          <i className='bi bi-align-end' />
          <div className='label'>align-end</div>
        </div>
        <div className='icon'>
          <i className='bi bi-align-middle' />
          <div className='label'>align-middle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-align-start' />
          <div className='label'>align-start</div>
        </div>
        <div className='icon'>
          <i className='bi bi-align-top' />
          <div className='label'>align-top</div>
        </div>
        <div className='icon'>
          <i className='bi bi-alt' />
          <div className='label'>alt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-app-indicator' />
          <div className='label'>app-indicator</div>
        </div>
        <div className='icon'>
          <i className='bi bi-app' />
          <div className='label'>app</div>
        </div>
        <div className='icon'>
          <i className='bi bi-archive-fill' />
          <div className='label'>archive-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-archive' />
          <div className='label'>archive</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-90deg-down' />
          <div className='label'>arrow-90deg-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-90deg-left' />
          <div className='label'>arrow-90deg-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-90deg-right' />
          <div className='label'>arrow-90deg-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-90deg-up' />
          <div className='label'>arrow-90deg-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-bar-down' />
          <div className='label'>arrow-bar-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-bar-left' />
          <div className='label'>arrow-bar-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-bar-right' />
          <div className='label'>arrow-bar-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-bar-up' />
          <div className='label'>arrow-bar-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-clockwise' />
          <div className='label'>arrow-clockwise</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-counterclockwise' />
          <div className='label'>arrow-counterclockwise</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-circle-fill' />
          <div className='label'>arrow-down-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-circle' />
          <div className='label'>arrow-down-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-left-circle-fill' />
          <div className='label'>arrow-down-left-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-left-circle' />
          <div className='label'>arrow-down-left-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-left-square-fill' />
          <div className='label'>arrow-down-left-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-left-square' />
          <div className='label'>arrow-down-left-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-left' />
          <div className='label'>arrow-down-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-right-circle-fill' />
          <div className='label'>arrow-down-right-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-right-circle' />
          <div className='label'>arrow-down-right-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-right-square-fill' />
          <div className='label'>arrow-down-right-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-right-square' />
          <div className='label'>arrow-down-right-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-right' />
          <div className='label'>arrow-down-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-short' />
          <div className='label'>arrow-down-short</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-square-fill' />
          <div className='label'>arrow-down-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-square' />
          <div className='label'>arrow-down-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down-up' />
          <div className='label'>arrow-down-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-down' />
          <div className='label'>arrow-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-left-circle-fill' />
          <div className='label'>arrow-left-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-left-circle' />
          <div className='label'>arrow-left-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-left-right' />
          <div className='label'>arrow-left-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-left-short' />
          <div className='label'>arrow-left-short</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-left-square-fill' />
          <div className='label'>arrow-left-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-left-square' />
          <div className='label'>arrow-left-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-left' />
          <div className='label'>arrow-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-repeat' />
          <div className='label'>arrow-repeat</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-return-left' />
          <div className='label'>arrow-return-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-return-right' />
          <div className='label'>arrow-return-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-right-circle-fill' />
          <div className='label'>arrow-right-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-right-circle' />
          <div className='label'>arrow-right-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-right-short' />
          <div className='label'>arrow-right-short</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-right-square-fill' />
          <div className='label'>arrow-right-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-right-square' />
          <div className='label'>arrow-right-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-right' />
          <div className='label'>arrow-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-circle-fill' />
          <div className='label'>arrow-up-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-circle' />
          <div className='label'>arrow-up-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-left-circle-fill' />
          <div className='label'>arrow-up-left-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-left-circle' />
          <div className='label'>arrow-up-left-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-left-square-fill' />
          <div className='label'>arrow-up-left-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-left-square' />
          <div className='label'>arrow-up-left-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-left' />
          <div className='label'>arrow-up-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-right-circle-fill' />
          <div className='label'>arrow-up-right-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-right-circle' />
          <div className='label'>arrow-up-right-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-right-square-fill' />
          <div className='label'>arrow-up-right-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-right-square' />
          <div className='label'>arrow-up-right-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-right' />
          <div className='label'>arrow-up-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-short' />
          <div className='label'>arrow-up-short</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-square-fill' />
          <div className='label'>arrow-up-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up-square' />
          <div className='label'>arrow-up-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrow-up' />
          <div className='label'>arrow-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrows-angle-contract' />
          <div className='label'>arrows-angle-contract</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrows-angle-expand' />
          <div className='label'>arrows-angle-expand</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrows-collapse' />
          <div className='label'>arrows-collapse</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrows-expand' />
          <div className='label'>arrows-expand</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrows-fullscreen' />
          <div className='label'>arrows-fullscreen</div>
        </div>
        <div className='icon'>
          <i className='bi bi-arrows-move' />
          <div className='label'>arrows-move</div>
        </div>
        <div className='icon'>
          <i className='bi bi-aspect-ratio-fill' />
          <div className='label'>aspect-ratio-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-aspect-ratio' />
          <div className='label'>aspect-ratio</div>
        </div>
        <div className='icon'>
          <i className='bi bi-asterisk' />
          <div className='label'>asterisk</div>
        </div>
        <div className='icon'>
          <i className='bi bi-at' />
          <div className='label'>at</div>
        </div>
        <div className='icon'>
          <i className='bi bi-award-fill' />
          <div className='label'>award-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-award' />
          <div className='label'>award</div>
        </div>
        <div className='icon'>
          <i className='bi bi-back' />
          <div className='label'>back</div>
        </div>
        <div className='icon'>
          <i className='bi bi-backspace-fill' />
          <div className='label'>backspace-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-backspace-reverse-fill' />
          <div className='label'>backspace-reverse-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-backspace-reverse' />
          <div className='label'>backspace-reverse</div>
        </div>
        <div className='icon'>
          <i className='bi bi-backspace' />
          <div className='label'>backspace</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-3d-fill' />
          <div className='label'>badge-3d-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-3d' />
          <div className='label'>badge-3d</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-4k-fill' />
          <div className='label'>badge-4k-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-4k' />
          <div className='label'>badge-4k</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-8k-fill' />
          <div className='label'>badge-8k-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-8k' />
          <div className='label'>badge-8k</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-ad-fill' />
          <div className='label'>badge-ad-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-ad' />
          <div className='label'>badge-ad</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-ar-fill' />
          <div className='label'>badge-ar-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-ar' />
          <div className='label'>badge-ar</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-cc-fill' />
          <div className='label'>badge-cc-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-cc' />
          <div className='label'>badge-cc</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-hd-fill' />
          <div className='label'>badge-hd-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-hd' />
          <div className='label'>badge-hd</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-tm-fill' />
          <div className='label'>badge-tm-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-tm' />
          <div className='label'>badge-tm</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-vo-fill' />
          <div className='label'>badge-vo-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-vo' />
          <div className='label'>badge-vo</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-vr-fill' />
          <div className='label'>badge-vr-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-vr' />
          <div className='label'>badge-vr</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-wc-fill' />
          <div className='label'>badge-wc-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-badge-wc' />
          <div className='label'>badge-wc</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bag-check-fill' />
          <div className='label'>bag-check-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bag-check' />
          <div className='label'>bag-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bag-dash-fill' />
          <div className='label'>bag-dash-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bag-dash' />
          <div className='label'>bag-dash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bag-fill' />
          <div className='label'>bag-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bag-plus-fill' />
          <div className='label'>bag-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bag-plus' />
          <div className='label'>bag-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bag-x-fill' />
          <div className='label'>bag-x-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bag-x' />
          <div className='label'>bag-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bag' />
          <div className='label'>bag</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bank' />
          <div className='label'>bank</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bank2' />
          <div className='label'>bank2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bar-chart-fill' />
          <div className='label'>bar-chart-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bar-chart-line-fill' />
          <div className='label'>bar-chart-line-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bar-chart-line' />
          <div className='label'>bar-chart-line</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bar-chart-steps' />
          <div className='label'>bar-chart-steps</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bar-chart' />
          <div className='label'>bar-chart</div>
        </div>
        <div className='icon'>
          <i className='bi bi-basket-fill' />
          <div className='label'>basket-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-basket' />
          <div className='label'>basket</div>
        </div>
        <div className='icon'>
          <i className='bi bi-basket2-fill' />
          <div className='label'>basket2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-basket2' />
          <div className='label'>basket2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-basket3-fill' />
          <div className='label'>basket3-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-basket3' />
          <div className='label'>basket3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-battery-charging' />
          <div className='label'>battery-charging</div>
        </div>
        <div className='icon'>
          <i className='bi bi-battery-full' />
          <div className='label'>battery-full</div>
        </div>
        <div className='icon'>
          <i className='bi bi-battery-half' />
          <div className='label'>battery-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-battery' />
          <div className='label'>battery</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bell-fill' />
          <div className='label'>bell-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bell-slash-fill' />
          <div className='label'>bell-slash-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bell-slash' />
          <div className='label'>bell-slash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bell' />
          <div className='label'>bell</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bezier' />
          <div className='label'>bezier</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bezier2' />
          <div className='label'>bezier2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bicycle' />
          <div className='label'>bicycle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-binoculars-fill' />
          <div className='label'>binoculars-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-binoculars' />
          <div className='label'>binoculars</div>
        </div>
        <div className='icon'>
          <i className='bi bi-blockquote-left' />
          <div className='label'>blockquote-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-blockquote-right' />
          <div className='label'>blockquote-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-book-fill' />
          <div className='label'>book-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-book-half' />
          <div className='label'>book-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-book' />
          <div className='label'>book</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-check-fill' />
          <div className='label'>bookmark-check-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-check' />
          <div className='label'>bookmark-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-dash-fill' />
          <div className='label'>bookmark-dash-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-dash' />
          <div className='label'>bookmark-dash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-fill' />
          <div className='label'>bookmark-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-heart-fill' />
          <div className='label'>bookmark-heart-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-heart' />
          <div className='label'>bookmark-heart</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-plus-fill' />
          <div className='label'>bookmark-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-plus' />
          <div className='label'>bookmark-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-star-fill' />
          <div className='label'>bookmark-star-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-star' />
          <div className='label'>bookmark-star</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-x-fill' />
          <div className='label'>bookmark-x-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark-x' />
          <div className='label'>bookmark-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmark' />
          <div className='label'>bookmark</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmarks-fill' />
          <div className='label'>bookmarks-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookmarks' />
          <div className='label'>bookmarks</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bookshelf' />
          <div className='label'>bookshelf</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bootstrap-fill' />
          <div className='label'>bootstrap-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bootstrap-reboot' />
          <div className='label'>bootstrap-reboot</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bootstrap' />
          <div className='label'>bootstrap</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-all' />
          <div className='label'>border-all</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-bottom' />
          <div className='label'>border-bottom</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-center' />
          <div className='label'>border-center</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-inner' />
          <div className='label'>border-inner</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-left' />
          <div className='label'>border-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-middle' />
          <div className='label'>border-middle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-outer' />
          <div className='label'>border-outer</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-right' />
          <div className='label'>border-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-style' />
          <div className='label'>border-style</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-top' />
          <div className='label'>border-top</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border-width' />
          <div className='label'>border-width</div>
        </div>
        <div className='icon'>
          <i className='bi bi-border' />
          <div className='label'>border</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bounding-box-circles' />
          <div className='label'>bounding-box-circles</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bounding-box' />
          <div className='label'>bounding-box</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-down-left' />
          <div className='label'>box-arrow-down-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-down-right' />
          <div className='label'>box-arrow-down-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-down' />
          <div className='label'>box-arrow-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-in-down-left' />
          <div className='label'>box-arrow-in-down-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-in-down-right' />
          <div className='label'>box-arrow-in-down-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-in-down' />
          <div className='label'>box-arrow-in-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-in-left' />
          <div className='label'>box-arrow-in-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-in-right' />
          <div className='label'>box-arrow-in-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-in-up-left' />
          <div className='label'>box-arrow-in-up-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-in-up-right' />
          <div className='label'>box-arrow-in-up-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-in-up' />
          <div className='label'>box-arrow-in-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-left' />
          <div className='label'>box-arrow-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-right' />
          <div className='label'>box-arrow-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-up-left' />
          <div className='label'>box-arrow-up-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-up-right' />
          <div className='label'>box-arrow-up-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-arrow-up' />
          <div className='label'>box-arrow-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box-seam' />
          <div className='label'>box-seam</div>
        </div>
        <div className='icon'>
          <i className='bi bi-box' />
          <div className='label'>box</div>
        </div>
        <div className='icon'>
          <i className='bi bi-braces' />
          <div className='label'>braces</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bricks' />
          <div className='label'>bricks</div>
        </div>
        <div className='icon'>
          <i className='bi bi-briefcase-fill' />
          <div className='label'>briefcase-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-briefcase' />
          <div className='label'>briefcase</div>
        </div>
        <div className='icon'>
          <i className='bi bi-brightness-alt-high-fill' />
          <div className='label'>brightness-alt-high-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-brightness-alt-high' />
          <div className='label'>brightness-alt-high</div>
        </div>
        <div className='icon'>
          <i className='bi bi-brightness-alt-low-fill' />
          <div className='label'>brightness-alt-low-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-brightness-alt-low' />
          <div className='label'>brightness-alt-low</div>
        </div>
        <div className='icon'>
          <i className='bi bi-brightness-high-fill' />
          <div className='label'>brightness-high-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-brightness-high' />
          <div className='label'>brightness-high</div>
        </div>
        <div className='icon'>
          <i className='bi bi-brightness-low-fill' />
          <div className='label'>brightness-low-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-brightness-low' />
          <div className='label'>brightness-low</div>
        </div>
        <div className='icon'>
          <i className='bi bi-broadcast-pin' />
          <div className='label'>broadcast-pin</div>
        </div>
        <div className='icon'>
          <i className='bi bi-broadcast' />
          <div className='label'>broadcast</div>
        </div>
        <div className='icon'>
          <i className='bi bi-brush-fill' />
          <div className='label'>brush-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-brush' />
          <div className='label'>brush</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bucket-fill' />
          <div className='label'>bucket-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bucket' />
          <div className='label'>bucket</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bug-fill' />
          <div className='label'>bug-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bug' />
          <div className='label'>bug</div>
        </div>
        <div className='icon'>
          <i className='bi bi-building' />
          <div className='label'>building</div>
        </div>
        <div className='icon'>
          <i className='bi bi-bullseye' />
          <div className='label'>bullseye</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calculator-fill' />
          <div className='label'>calculator-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calculator' />
          <div className='label'>calculator</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-check-fill' />
          <div className='label'>calendar-check-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-check' />
          <div className='label'>calendar-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-date-fill' />
          <div className='label'>calendar-date-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-date' />
          <div className='label'>calendar-date</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-day-fill' />
          <div className='label'>calendar-day-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-day' />
          <div className='label'>calendar-day</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-event-fill' />
          <div className='label'>calendar-event-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-event' />
          <div className='label'>calendar-event</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-fill' />
          <div className='label'>calendar-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-minus-fill' />
          <div className='label'>calendar-minus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-minus' />
          <div className='label'>calendar-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-month-fill' />
          <div className='label'>calendar-month-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-month' />
          <div className='label'>calendar-month</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-plus-fill' />
          <div className='label'>calendar-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-plus' />
          <div className='label'>calendar-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-range-fill' />
          <div className='label'>calendar-range-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-range' />
          <div className='label'>calendar-range</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-week-fill' />
          <div className='label'>calendar-week-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-week' />
          <div className='label'>calendar-week</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-x-fill' />
          <div className='label'>calendar-x-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar-x' />
          <div className='label'>calendar-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar' />
          <div className='label'>calendar</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-check-fill' />
          <div className='label'>calendar2-check-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-check' />
          <div className='label'>calendar2-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-date-fill' />
          <div className='label'>calendar2-date-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-date' />
          <div className='label'>calendar2-date</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-day-fill' />
          <div className='label'>calendar2-day-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-day' />
          <div className='label'>calendar2-day</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-event-fill' />
          <div className='label'>calendar2-event-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-event' />
          <div className='label'>calendar2-event</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-fill' />
          <div className='label'>calendar2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-minus-fill' />
          <div className='label'>calendar2-minus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-minus' />
          <div className='label'>calendar2-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-month-fill' />
          <div className='label'>calendar2-month-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-month' />
          <div className='label'>calendar2-month</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-plus-fill' />
          <div className='label'>calendar2-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-plus' />
          <div className='label'>calendar2-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-range-fill' />
          <div className='label'>calendar2-range-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-range' />
          <div className='label'>calendar2-range</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-week-fill' />
          <div className='label'>calendar2-week-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-week' />
          <div className='label'>calendar2-week</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-x-fill' />
          <div className='label'>calendar2-x-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2-x' />
          <div className='label'>calendar2-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar2' />
          <div className='label'>calendar2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar3-event-fill' />
          <div className='label'>calendar3-event-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar3-event' />
          <div className='label'>calendar3-event</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar3-fill' />
          <div className='label'>calendar3-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar3-range-fill' />
          <div className='label'>calendar3-range-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar3-range' />
          <div className='label'>calendar3-range</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar3-week-fill' />
          <div className='label'>calendar3-week-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar3-week' />
          <div className='label'>calendar3-week</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar3' />
          <div className='label'>calendar3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar4-event' />
          <div className='label'>calendar4-event</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar4-range' />
          <div className='label'>calendar4-range</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar4-week' />
          <div className='label'>calendar4-week</div>
        </div>
        <div className='icon'>
          <i className='bi bi-calendar4' />
          <div className='label'>calendar4</div>
        </div>
        <div className='icon'>
          <i className='bi bi-camera-fill' />
          <div className='label'>camera-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-camera-reels-fill' />
          <div className='label'>camera-reels-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-camera-reels' />
          <div className='label'>camera-reels</div>
        </div>
        <div className='icon'>
          <i className='bi bi-camera-video-fill' />
          <div className='label'>camera-video-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-camera-video-off-fill' />
          <div className='label'>camera-video-off-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-camera-video-off' />
          <div className='label'>camera-video-off</div>
        </div>
        <div className='icon'>
          <i className='bi bi-camera-video' />
          <div className='label'>camera-video</div>
        </div>
        <div className='icon'>
          <i className='bi bi-camera' />
          <div className='label'>camera</div>
        </div>
        <div className='icon'>
          <i className='bi bi-camera2' />
          <div className='label'>camera2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-capslock-fill' />
          <div className='label'>capslock-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-capslock' />
          <div className='label'>capslock</div>
        </div>
        <div className='icon'>
          <i className='bi bi-card-checklist' />
          <div className='label'>card-checklist</div>
        </div>
        <div className='icon'>
          <i className='bi bi-card-heading' />
          <div className='label'>card-heading</div>
        </div>
        <div className='icon'>
          <i className='bi bi-card-image' />
          <div className='label'>card-image</div>
        </div>
        <div className='icon'>
          <i className='bi bi-card-list' />
          <div className='label'>card-list</div>
        </div>
        <div className='icon'>
          <i className='bi bi-card-text' />
          <div className='label'>card-text</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-down-fill' />
          <div className='label'>caret-down-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-down-square-fill' />
          <div className='label'>caret-down-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-down-square' />
          <div className='label'>caret-down-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-down' />
          <div className='label'>caret-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-left-fill' />
          <div className='label'>caret-left-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-left-square-fill' />
          <div className='label'>caret-left-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-left-square' />
          <div className='label'>caret-left-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-left' />
          <div className='label'>caret-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-right-fill' />
          <div className='label'>caret-right-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-right-square-fill' />
          <div className='label'>caret-right-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-right-square' />
          <div className='label'>caret-right-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-right' />
          <div className='label'>caret-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-up-fill' />
          <div className='label'>caret-up-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-up-square-fill' />
          <div className='label'>caret-up-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-up-square' />
          <div className='label'>caret-up-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-caret-up' />
          <div className='label'>caret-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart-check-fill' />
          <div className='label'>cart-check-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart-check' />
          <div className='label'>cart-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart-dash-fill' />
          <div className='label'>cart-dash-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart-dash' />
          <div className='label'>cart-dash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart-fill' />
          <div className='label'>cart-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart-plus-fill' />
          <div className='label'>cart-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart-plus' />
          <div className='label'>cart-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart-x-fill' />
          <div className='label'>cart-x-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart-x' />
          <div className='label'>cart-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart' />
          <div className='label'>cart</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart2' />
          <div className='label'>cart2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart3' />
          <div className='label'>cart3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cart4' />
          <div className='label'>cart4</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cash-coin' />
          <div className='label'>cash-coin</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cash-stack' />
          <div className='label'>cash-stack</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cash' />
          <div className='label'>cash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cast' />
          <div className='label'>cast</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-dots-fill' />
          <div className='label'>chat-dots-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-dots' />
          <div className='label'>chat-dots</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-fill' />
          <div className='label'>chat-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-left-dots-fill' />
          <div className='label'>chat-left-dots-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-left-dots' />
          <div className='label'>chat-left-dots</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-left-fill' />
          <div className='label'>chat-left-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-left-quote-fill' />
          <div className='label'>chat-left-quote-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-left-quote' />
          <div className='label'>chat-left-quote</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-left-text-fill' />
          <div className='label'>chat-left-text-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-left-text' />
          <div className='label'>chat-left-text</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-left' />
          <div className='label'>chat-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-quote-fill' />
          <div className='label'>chat-quote-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-quote' />
          <div className='label'>chat-quote</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-right-dots-fill' />
          <div className='label'>chat-right-dots-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-right-dots' />
          <div className='label'>chat-right-dots</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-right-fill' />
          <div className='label'>chat-right-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-right-quote-fill' />
          <div className='label'>chat-right-quote-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-right-quote' />
          <div className='label'>chat-right-quote</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-right-text-fill' />
          <div className='label'>chat-right-text-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-right-text' />
          <div className='label'>chat-right-text</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-right' />
          <div className='label'>chat-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-square-dots-fill' />
          <div className='label'>chat-square-dots-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-square-dots' />
          <div className='label'>chat-square-dots</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-square-fill' />
          <div className='label'>chat-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-square-quote-fill' />
          <div className='label'>chat-square-quote-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-square-quote' />
          <div className='label'>chat-square-quote</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-square-text-fill' />
          <div className='label'>chat-square-text-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-square-text' />
          <div className='label'>chat-square-text</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-square' />
          <div className='label'>chat-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-text-fill' />
          <div className='label'>chat-text-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat-text' />
          <div className='label'>chat-text</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chat' />
          <div className='label'>chat</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check-all' />
          <div className='label'>check-all</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check-circle-fill' />
          <div className='label'>check-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check-circle' />
          <div className='label'>check-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check-lg' />
          <div className='label'>check-lg</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check-square-fill' />
          <div className='label'>check-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check-square' />
          <div className='label'>check-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check' />
          <div className='label'>check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check2-all' />
          <div className='label'>check2-all</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check2-circle' />
          <div className='label'>check2-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check2-square' />
          <div className='label'>check2-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-check2' />
          <div className='label'>check2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-bar-contract' />
          <div className='label'>chevron-bar-contract</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-bar-down' />
          <div className='label'>chevron-bar-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-bar-expand' />
          <div className='label'>chevron-bar-expand</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-bar-left' />
          <div className='label'>chevron-bar-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-bar-right' />
          <div className='label'>chevron-bar-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-bar-up' />
          <div className='label'>chevron-bar-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-compact-down' />
          <div className='label'>chevron-compact-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-compact-left' />
          <div className='label'>chevron-compact-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-compact-right' />
          <div className='label'>chevron-compact-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-compact-up' />
          <div className='label'>chevron-compact-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-contract' />
          <div className='label'>chevron-contract</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-double-down' />
          <div className='label'>chevron-double-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-double-left' />
          <div className='label'>chevron-double-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-double-right' />
          <div className='label'>chevron-double-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-double-up' />
          <div className='label'>chevron-double-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-down' />
          <div className='label'>chevron-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-expand' />
          <div className='label'>chevron-expand</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-left' />
          <div className='label'>chevron-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-right' />
          <div className='label'>chevron-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-chevron-up' />
          <div className='label'>chevron-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-circle-fill' />
          <div className='label'>circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-circle-half' />
          <div className='label'>circle-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-circle-square' />
          <div className='label'>circle-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-circle' />
          <div className='label'>circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clipboard-check' />
          <div className='label'>clipboard-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clipboard-data' />
          <div className='label'>clipboard-data</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clipboard-minus' />
          <div className='label'>clipboard-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clipboard-plus' />
          <div className='label'>clipboard-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clipboard-x' />
          <div className='label'>clipboard-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clipboard' />
          <div className='label'>clipboard</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clock-fill' />
          <div className='label'>clock-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clock-history' />
          <div className='label'>clock-history</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clock' />
          <div className='label'>clock</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-arrow-down-fill' />
          <div className='label'>cloud-arrow-down-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-arrow-down' />
          <div className='label'>cloud-arrow-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-arrow-up-fill' />
          <div className='label'>cloud-arrow-up-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-arrow-up' />
          <div className='label'>cloud-arrow-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-check-fill' />
          <div className='label'>cloud-check-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-check' />
          <div className='label'>cloud-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-download-fill' />
          <div className='label'>cloud-download-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-download' />
          <div className='label'>cloud-download</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-drizzle-fill' />
          <div className='label'>cloud-drizzle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-drizzle' />
          <div className='label'>cloud-drizzle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-fill' />
          <div className='label'>cloud-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-fog-fill' />
          <div className='label'>cloud-fog-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-fog' />
          <div className='label'>cloud-fog</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-fog2-fill' />
          <div className='label'>cloud-fog2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-fog2' />
          <div className='label'>cloud-fog2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-hail-fill' />
          <div className='label'>cloud-hail-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-hail' />
          <div className='label'>cloud-hail</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-haze-1' />
          <div className='label'>cloud-haze-1</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-haze-fill' />
          <div className='label'>cloud-haze-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-haze' />
          <div className='label'>cloud-haze</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-haze2-fill' />
          <div className='label'>cloud-haze2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-lightning-fill' />
          <div className='label'>cloud-lightning-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-lightning-rain-fill' />
          <div className='label'>cloud-lightning-rain-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-lightning-rain' />
          <div className='label'>cloud-lightning-rain</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-lightning' />
          <div className='label'>cloud-lightning</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-minus-fill' />
          <div className='label'>cloud-minus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-minus' />
          <div className='label'>cloud-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-moon-fill' />
          <div className='label'>cloud-moon-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-moon' />
          <div className='label'>cloud-moon</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-plus-fill' />
          <div className='label'>cloud-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-plus' />
          <div className='label'>cloud-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-rain-fill' />
          <div className='label'>cloud-rain-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-rain-heavy-fill' />
          <div className='label'>cloud-rain-heavy-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-rain-heavy' />
          <div className='label'>cloud-rain-heavy</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-rain' />
          <div className='label'>cloud-rain</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-slash-fill' />
          <div className='label'>cloud-slash-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-slash' />
          <div className='label'>cloud-slash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-sleet-fill' />
          <div className='label'>cloud-sleet-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-sleet' />
          <div className='label'>cloud-sleet</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-snow-fill' />
          <div className='label'>cloud-snow-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-snow' />
          <div className='label'>cloud-snow</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-sun-fill' />
          <div className='label'>cloud-sun-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-sun' />
          <div className='label'>cloud-sun</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-upload-fill' />
          <div className='label'>cloud-upload-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud-upload' />
          <div className='label'>cloud-upload</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloud' />
          <div className='label'>cloud</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clouds-fill' />
          <div className='label'>clouds-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-clouds' />
          <div className='label'>clouds</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloudy-fill' />
          <div className='label'>cloudy-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cloudy' />
          <div className='label'>cloudy</div>
        </div>
        <div className='icon'>
          <i className='bi bi-code-slash' />
          <div className='label'>code-slash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-code-square' />
          <div className='label'>code-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-code' />
          <div className='label'>code</div>
        </div>
        <div className='icon'>
          <i className='bi bi-coin' />
          <div className='label'>coin</div>
        </div>
        <div className='icon'>
          <i className='bi bi-collection-fill' />
          <div className='label'>collection-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-collection-play-fill' />
          <div className='label'>collection-play-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-collection-play' />
          <div className='label'>collection-play</div>
        </div>
        <div className='icon'>
          <i className='bi bi-collection' />
          <div className='label'>collection</div>
        </div>
        <div className='icon'>
          <i className='bi bi-columns-gap' />
          <div className='label'>columns-gap</div>
        </div>
        <div className='icon'>
          <i className='bi bi-columns' />
          <div className='label'>columns</div>
        </div>
        <div className='icon'>
          <i className='bi bi-command' />
          <div className='label'>command</div>
        </div>
        <div className='icon'>
          <i className='bi bi-compass-fill' />
          <div className='label'>compass-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-compass' />
          <div className='label'>compass</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cone-striped' />
          <div className='label'>cone-striped</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cone' />
          <div className='label'>cone</div>
        </div>
        <div className='icon'>
          <i className='bi bi-controller' />
          <div className='label'>controller</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cpu-fill' />
          <div className='label'>cpu-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cpu' />
          <div className='label'>cpu</div>
        </div>
        <div className='icon'>
          <i className='bi bi-credit-card-2-back-fill' />
          <div className='label'>credit-card-2-back-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-credit-card-2-back' />
          <div className='label'>credit-card-2-back</div>
        </div>
        <div className='icon'>
          <i className='bi bi-credit-card-2-front-fill' />
          <div className='label'>credit-card-2-front-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-credit-card-2-front' />
          <div className='label'>credit-card-2-front</div>
        </div>
        <div className='icon'>
          <i className='bi bi-credit-card-fill' />
          <div className='label'>credit-card-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-credit-card' />
          <div className='label'>credit-card</div>
        </div>
        <div className='icon'>
          <i className='bi bi-crop' />
          <div className='label'>crop</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cup-fill' />
          <div className='label'>cup-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cup-straw' />
          <div className='label'>cup-straw</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cup' />
          <div className='label'>cup</div>
        </div>
        <div className='icon'>
          <i className='bi bi-currency-bitcoin' />
          <div className='label'>currency-bitcoin</div>
        </div>
        <div className='icon'>
          <i className='bi bi-currency-dollar' />
          <div className='label'>currency-dollar</div>
        </div>
        <div className='icon'>
          <i className='bi bi-currency-euro' />
          <div className='label'>currency-euro</div>
        </div>
        <div className='icon'>
          <i className='bi bi-currency-exchange' />
          <div className='label'>currency-exchange</div>
        </div>
        <div className='icon'>
          <i className='bi bi-currency-pound' />
          <div className='label'>currency-pound</div>
        </div>
        <div className='icon'>
          <i className='bi bi-currency-yen' />
          <div className='label'>currency-yen</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cursor-fill' />
          <div className='label'>cursor-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cursor-text' />
          <div className='label'>cursor-text</div>
        </div>
        <div className='icon'>
          <i className='bi bi-cursor' />
          <div className='label'>cursor</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dash-circle-dotted' />
          <div className='label'>dash-circle-dotted</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dash-circle-fill' />
          <div className='label'>dash-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dash-circle' />
          <div className='label'>dash-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dash-lg' />
          <div className='label'>dash-lg</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dash-square-dotted' />
          <div className='label'>dash-square-dotted</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dash-square-fill' />
          <div className='label'>dash-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dash-square' />
          <div className='label'>dash-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dash' />
          <div className='label'>dash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-diagram-2-fill' />
          <div className='label'>diagram-2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-diagram-2' />
          <div className='label'>diagram-2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-diagram-3-fill' />
          <div className='label'>diagram-3-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-diagram-3' />
          <div className='label'>diagram-3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-diamond-fill' />
          <div className='label'>diamond-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-diamond-half' />
          <div className='label'>diamond-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-diamond' />
          <div className='label'>diamond</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-1-fill' />
          <div className='label'>dice-1-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-1' />
          <div className='label'>dice-1</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-2-fill' />
          <div className='label'>dice-2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-2' />
          <div className='label'>dice-2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-3-fill' />
          <div className='label'>dice-3-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-3' />
          <div className='label'>dice-3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-4-fill' />
          <div className='label'>dice-4-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-4' />
          <div className='label'>dice-4</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-5-fill' />
          <div className='label'>dice-5-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-5' />
          <div className='label'>dice-5</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-6-fill' />
          <div className='label'>dice-6-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dice-6' />
          <div className='label'>dice-6</div>
        </div>
        <div className='icon'>
          <i className='bi bi-disc-fill' />
          <div className='label'>disc-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-disc' />
          <div className='label'>disc</div>
        </div>
        <div className='icon'>
          <i className='bi bi-discord' />
          <div className='label'>discord</div>
        </div>
        <div className='icon'>
          <i className='bi bi-display-fill' />
          <div className='label'>display-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-display' />
          <div className='label'>display</div>
        </div>
        <div className='icon'>
          <i className='bi bi-distribute-horizontal' />
          <div className='label'>distribute-horizontal</div>
        </div>
        <div className='icon'>
          <i className='bi bi-distribute-vertical' />
          <div className='label'>distribute-vertical</div>
        </div>
        <div className='icon'>
          <i className='bi bi-door-closed-fill' />
          <div className='label'>door-closed-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-door-closed' />
          <div className='label'>door-closed</div>
        </div>
        <div className='icon'>
          <i className='bi bi-door-open-fill' />
          <div className='label'>door-open-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-door-open' />
          <div className='label'>door-open</div>
        </div>
        <div className='icon'>
          <i className='bi bi-dot' />
          <div className='label'>dot</div>
        </div>
        <div className='icon'>
          <i className='bi bi-download' />
          <div className='label'>download</div>
        </div>
        <div className='icon'>
          <i className='bi bi-droplet-fill' />
          <div className='label'>droplet-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-droplet-half' />
          <div className='label'>droplet-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-droplet' />
          <div className='label'>droplet</div>
        </div>
        <div className='icon'>
          <i className='bi bi-earbuds' />
          <div className='label'>earbuds</div>
        </div>
        <div className='icon'>
          <i className='bi bi-easel-fill' />
          <div className='label'>easel-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-easel' />
          <div className='label'>easel</div>
        </div>
        <div className='icon'>
          <i className='bi bi-egg-fill' />
          <div className='label'>egg-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-egg-fried' />
          <div className='label'>egg-fried</div>
        </div>
        <div className='icon'>
          <i className='bi bi-egg' />
          <div className='label'>egg</div>
        </div>
        <div className='icon'>
          <i className='bi bi-eject-fill' />
          <div className='label'>eject-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-eject' />
          <div className='label'>eject</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-angry-fill' />
          <div className='label'>emoji-angry-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-angry' />
          <div className='label'>emoji-angry</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-dizzy-fill' />
          <div className='label'>emoji-dizzy-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-dizzy' />
          <div className='label'>emoji-dizzy</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-expressionless-fill' />
          <div className='label'>emoji-expressionless-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-expressionless' />
          <div className='label'>emoji-expressionless</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-frown-fill' />
          <div className='label'>emoji-frown-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-frown' />
          <div className='label'>emoji-frown</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-heart-eyes-fill' />
          <div className='label'>emoji-heart-eyes-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-heart-eyes' />
          <div className='label'>emoji-heart-eyes</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-laughing-fill' />
          <div className='label'>emoji-laughing-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-laughing' />
          <div className='label'>emoji-laughing</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-neutral-fill' />
          <div className='label'>emoji-neutral-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-neutral' />
          <div className='label'>emoji-neutral</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-smile-fill' />
          <div className='label'>emoji-smile-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-smile-upside-down-fill' />
          <div className='label'>emoji-smile-upside-down-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-smile-upside-down' />
          <div className='label'>emoji-smile-upside-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-smile' />
          <div className='label'>emoji-smile</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-sunglasses-fill' />
          <div className='label'>emoji-sunglasses-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-sunglasses' />
          <div className='label'>emoji-sunglasses</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-wink-fill' />
          <div className='label'>emoji-wink-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-emoji-wink' />
          <div className='label'>emoji-wink</div>
        </div>
        <div className='icon'>
          <i className='bi bi-envelope-fill' />
          <div className='label'>envelope-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-envelope-open-fill' />
          <div className='label'>envelope-open-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-envelope-open' />
          <div className='label'>envelope-open</div>
        </div>
        <div className='icon'>
          <i className='bi bi-envelope' />
          <div className='label'>envelope</div>
        </div>
        <div className='icon'>
          <i className='bi bi-eraser-fill' />
          <div className='label'>eraser-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-eraser' />
          <div className='label'>eraser</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-circle-fill' />
          <div className='label'>exclamation-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-circle' />
          <div className='label'>exclamation-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-diamond-fill' />
          <div className='label'>exclamation-diamond-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-diamond' />
          <div className='label'>exclamation-diamond</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-lg' />
          <div className='label'>exclamation-lg</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-octagon-fill' />
          <div className='label'>exclamation-octagon-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-octagon' />
          <div className='label'>exclamation-octagon</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-square-fill' />
          <div className='label'>exclamation-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-square' />
          <div className='label'>exclamation-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-triangle-fill' />
          <div className='label'>exclamation-triangle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation-triangle' />
          <div className='label'>exclamation-triangle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclamation' />
          <div className='label'>exclamation</div>
        </div>
        <div className='icon'>
          <i className='bi bi-exclude' />
          <div className='label'>exclude</div>
        </div>
        <div className='icon'>
          <i className='bi bi-eye-fill' />
          <div className='label'>eye-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-eye-slash-fill' />
          <div className='label'>eye-slash-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-eye-slash' />
          <div className='label'>eye-slash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-eye' />
          <div className='label'>eye</div>
        </div>
        <div className='icon'>
          <i className='bi bi-eyedropper' />
          <div className='label'>eyedropper</div>
        </div>
        <div className='icon'>
          <i className='bi bi-eyeglasses' />
          <div className='label'>eyeglasses</div>
        </div>
        <div className='icon'>
          <i className='bi bi-facebook' />
          <div className='label'>facebook</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-arrow-down-fill' />
          <div className='label'>file-arrow-down-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-arrow-down' />
          <div className='label'>file-arrow-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-arrow-up-fill' />
          <div className='label'>file-arrow-up-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-arrow-up' />
          <div className='label'>file-arrow-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-bar-graph-fill' />
          <div className='label'>file-bar-graph-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-bar-graph' />
          <div className='label'>file-bar-graph</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-binary-fill' />
          <div className='label'>file-binary-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-binary' />
          <div className='label'>file-binary</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-break-fill' />
          <div className='label'>file-break-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-break' />
          <div className='label'>file-break</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-check-fill' />
          <div className='label'>file-check-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-check' />
          <div className='label'>file-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-code-fill' />
          <div className='label'>file-code-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-code' />
          <div className='label'>file-code</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-diff-fill' />
          <div className='label'>file-diff-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-diff' />
          <div className='label'>file-diff</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-arrow-down-fill' />
          <div className='label'>file-earmark-arrow-down-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-arrow-down' />
          <div className='label'>file-earmark-arrow-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-arrow-up-fill' />
          <div className='label'>file-earmark-arrow-up-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-arrow-up' />
          <div className='label'>file-earmark-arrow-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-bar-graph-fill' />
          <div className='label'>file-earmark-bar-graph-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-bar-graph' />
          <div className='label'>file-earmark-bar-graph</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-binary-fill' />
          <div className='label'>file-earmark-binary-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-binary' />
          <div className='label'>file-earmark-binary</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-break-fill' />
          <div className='label'>file-earmark-break-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-break' />
          <div className='label'>file-earmark-break</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-check-fill' />
          <div className='label'>file-earmark-check-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-check' />
          <div className='label'>file-earmark-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-code-fill' />
          <div className='label'>file-earmark-code-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-code' />
          <div className='label'>file-earmark-code</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-diff-fill' />
          <div className='label'>file-earmark-diff-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-diff' />
          <div className='label'>file-earmark-diff</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-easel-fill' />
          <div className='label'>file-earmark-easel-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-easel' />
          <div className='label'>file-earmark-easel</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-excel-fill' />
          <div className='label'>file-earmark-excel-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-excel' />
          <div className='label'>file-earmark-excel</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-fill' />
          <div className='label'>file-earmark-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-font-fill' />
          <div className='label'>file-earmark-font-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-font' />
          <div className='label'>file-earmark-font</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-image-fill' />
          <div className='label'>file-earmark-image-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-image' />
          <div className='label'>file-earmark-image</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-lock-fill' />
          <div className='label'>file-earmark-lock-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-lock' />
          <div className='label'>file-earmark-lock</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-lock2-fill' />
          <div className='label'>file-earmark-lock2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-lock2' />
          <div className='label'>file-earmark-lock2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-medical-fill' />
          <div className='label'>file-earmark-medical-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-medical' />
          <div className='label'>file-earmark-medical</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-minus-fill' />
          <div className='label'>file-earmark-minus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-minus' />
          <div className='label'>file-earmark-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-music-fill' />
          <div className='label'>file-earmark-music-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-music' />
          <div className='label'>file-earmark-music</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-pdf-fill' />
          <div className='label'>file-earmark-pdf-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-pdf' />
          <div className='label'>file-earmark-pdf</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-person-fill' />
          <div className='label'>file-earmark-person-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-person' />
          <div className='label'>file-earmark-person</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-play-fill' />
          <div className='label'>file-earmark-play-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-play' />
          <div className='label'>file-earmark-play</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-plus-fill' />
          <div className='label'>file-earmark-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-plus' />
          <div className='label'>file-earmark-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-post-fill' />
          <div className='label'>file-earmark-post-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-post' />
          <div className='label'>file-earmark-post</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-ppt-fill' />
          <div className='label'>file-earmark-ppt-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-ppt' />
          <div className='label'>file-earmark-ppt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-richtext-fill' />
          <div className='label'>file-earmark-richtext-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-richtext' />
          <div className='label'>file-earmark-richtext</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-ruled-fill' />
          <div className='label'>file-earmark-ruled-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-ruled' />
          <div className='label'>file-earmark-ruled</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-slides-fill' />
          <div className='label'>file-earmark-slides-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-slides' />
          <div className='label'>file-earmark-slides</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-spreadsheet-fill' />
          <div className='label'>file-earmark-spreadsheet-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-spreadsheet' />
          <div className='label'>file-earmark-spreadsheet</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-text-fill' />
          <div className='label'>file-earmark-text-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-text' />
          <div className='label'>file-earmark-text</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-word-fill' />
          <div className='label'>file-earmark-word-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-word' />
          <div className='label'>file-earmark-word</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-x-fill' />
          <div className='label'>file-earmark-x-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-x' />
          <div className='label'>file-earmark-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-zip-fill' />
          <div className='label'>file-earmark-zip-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark-zip' />
          <div className='label'>file-earmark-zip</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-earmark' />
          <div className='label'>file-earmark</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-easel-fill' />
          <div className='label'>file-easel-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-easel' />
          <div className='label'>file-easel</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-excel-fill' />
          <div className='label'>file-excel-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-excel' />
          <div className='label'>file-excel</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-fill' />
          <div className='label'>file-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-font-fill' />
          <div className='label'>file-font-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-font' />
          <div className='label'>file-font</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-image-fill' />
          <div className='label'>file-image-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-image' />
          <div className='label'>file-image</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-lock-fill' />
          <div className='label'>file-lock-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-lock' />
          <div className='label'>file-lock</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-lock2-fill' />
          <div className='label'>file-lock2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-lock2' />
          <div className='label'>file-lock2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-medical-fill' />
          <div className='label'>file-medical-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-medical' />
          <div className='label'>file-medical</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-minus-fill' />
          <div className='label'>file-minus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-minus' />
          <div className='label'>file-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-music-fill' />
          <div className='label'>file-music-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-music' />
          <div className='label'>file-music</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-pdf-fill' />
          <div className='label'>file-pdf-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-pdf' />
          <div className='label'>file-pdf</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-person-fill' />
          <div className='label'>file-person-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-person' />
          <div className='label'>file-person</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-play-fill' />
          <div className='label'>file-play-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-play' />
          <div className='label'>file-play</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-plus-fill' />
          <div className='label'>file-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-plus' />
          <div className='label'>file-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-post-fill' />
          <div className='label'>file-post-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-post' />
          <div className='label'>file-post</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-ppt-fill' />
          <div className='label'>file-ppt-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-ppt' />
          <div className='label'>file-ppt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-richtext-fill' />
          <div className='label'>file-richtext-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-richtext' />
          <div className='label'>file-richtext</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-ruled-fill' />
          <div className='label'>file-ruled-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-ruled' />
          <div className='label'>file-ruled</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-slides-fill' />
          <div className='label'>file-slides-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-slides' />
          <div className='label'>file-slides</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-spreadsheet-fill' />
          <div className='label'>file-spreadsheet-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-spreadsheet' />
          <div className='label'>file-spreadsheet</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-text-fill' />
          <div className='label'>file-text-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-text' />
          <div className='label'>file-text</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-word-fill' />
          <div className='label'>file-word-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-word' />
          <div className='label'>file-word</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-x-fill' />
          <div className='label'>file-x-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-x' />
          <div className='label'>file-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-zip-fill' />
          <div className='label'>file-zip-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file-zip' />
          <div className='label'>file-zip</div>
        </div>
        <div className='icon'>
          <i className='bi bi-file' />
          <div className='label'>file</div>
        </div>
        <div className='icon'>
          <i className='bi bi-files-alt' />
          <div className='label'>files-alt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-files' />
          <div className='label'>files</div>
        </div>
        <div className='icon'>
          <i className='bi bi-film' />
          <div className='label'>film</div>
        </div>
        <div className='icon'>
          <i className='bi bi-filter-circle-fill' />
          <div className='label'>filter-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-filter-circle' />
          <div className='label'>filter-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-filter-left' />
          <div className='label'>filter-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-filter-right' />
          <div className='label'>filter-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-filter-square-fill' />
          <div className='label'>filter-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-filter-square' />
          <div className='label'>filter-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-filter' />
          <div className='label'>filter</div>
        </div>
        <div className='icon'>
          <i className='bi bi-flag-fill' />
          <div className='label'>flag-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-flag' />
          <div className='label'>flag</div>
        </div>
        <div className='icon'>
          <i className='bi bi-flower1' />
          <div className='label'>flower1</div>
        </div>
        <div className='icon'>
          <i className='bi bi-flower2' />
          <div className='label'>flower2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-flower3' />
          <div className='label'>flower3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-folder-check' />
          <div className='label'>folder-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-folder-fill' />
          <div className='label'>folder-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-folder-minus' />
          <div className='label'>folder-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-folder-plus' />
          <div className='label'>folder-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-folder-symlink-fill' />
          <div className='label'>folder-symlink-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-folder-symlink' />
          <div className='label'>folder-symlink</div>
        </div>
        <div className='icon'>
          <i className='bi bi-folder-x' />
          <div className='label'>folder-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-folder' />
          <div className='label'>folder</div>
        </div>
        <div className='icon'>
          <i className='bi bi-folder2-open' />
          <div className='label'>folder2-open</div>
        </div>
        <div className='icon'>
          <i className='bi bi-folder2' />
          <div className='label'>folder2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-fonts' />
          <div className='label'>fonts</div>
        </div>
        <div className='icon'>
          <i className='bi bi-forward-fill' />
          <div className='label'>forward-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-forward' />
          <div className='label'>forward</div>
        </div>
        <div className='icon'>
          <i className='bi bi-front' />
          <div className='label'>front</div>
        </div>
        <div className='icon'>
          <i className='bi bi-fullscreen-exit' />
          <div className='label'>fullscreen-exit</div>
        </div>
        <div className='icon'>
          <i className='bi bi-fullscreen' />
          <div className='label'>fullscreen</div>
        </div>
        <div className='icon'>
          <i className='bi bi-funnel-fill' />
          <div className='label'>funnel-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-funnel' />
          <div className='label'>funnel</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gear-fill' />
          <div className='label'>gear-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gear-wide-connected' />
          <div className='label'>gear-wide-connected</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gear-wide' />
          <div className='label'>gear-wide</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gear' />
          <div className='label'>gear</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gem' />
          <div className='label'>gem</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gender-ambiguous' />
          <div className='label'>gender-ambiguous</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gender-female' />
          <div className='label'>gender-female</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gender-male' />
          <div className='label'>gender-male</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gender-trans' />
          <div className='label'>gender-trans</div>
        </div>
        <div className='icon'>
          <i className='bi bi-geo-alt-fill' />
          <div className='label'>geo-alt-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-geo-alt' />
          <div className='label'>geo-alt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-geo-fill' />
          <div className='label'>geo-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-geo' />
          <div className='label'>geo</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gift-fill' />
          <div className='label'>gift-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-gift' />
          <div className='label'>gift</div>
        </div>
        <div className='icon'>
          <i className='bi bi-github' />
          <div className='label'>github</div>
        </div>
        <div className='icon'>
          <i className='bi bi-globe' />
          <div className='label'>globe</div>
        </div>
        <div className='icon'>
          <i className='bi bi-globe2' />
          <div className='label'>globe2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-google' />
          <div className='label'>google</div>
        </div>
        <div className='icon'>
          <i className='bi bi-graph-down' />
          <div className='label'>graph-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-graph-up' />
          <div className='label'>graph-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grid-1x2-fill' />
          <div className='label'>grid-1x2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grid-1x2' />
          <div className='label'>grid-1x2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grid-3x2-gap-fill' />
          <div className='label'>grid-3x2-gap-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grid-3x2-gap' />
          <div className='label'>grid-3x2-gap</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grid-3x2' />
          <div className='label'>grid-3x2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grid-3x3-gap-fill' />
          <div className='label'>grid-3x3-gap-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grid-3x3-gap' />
          <div className='label'>grid-3x3-gap</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grid-3x3' />
          <div className='label'>grid-3x3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grid-fill' />
          <div className='label'>grid-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grid' />
          <div className='label'>grid</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grip-horizontal' />
          <div className='label'>grip-horizontal</div>
        </div>
        <div className='icon'>
          <i className='bi bi-grip-vertical' />
          <div className='label'>grip-vertical</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hammer' />
          <div className='label'>hammer</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hand-index-fill' />
          <div className='label'>hand-index-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hand-index-thumb-fill' />
          <div className='label'>hand-index-thumb-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hand-index-thumb' />
          <div className='label'>hand-index-thumb</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hand-index' />
          <div className='label'>hand-index</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hand-thumbs-down-fill' />
          <div className='label'>hand-thumbs-down-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hand-thumbs-down' />
          <div className='label'>hand-thumbs-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hand-thumbs-up-fill' />
          <div className='label'>hand-thumbs-up-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hand-thumbs-up' />
          <div className='label'>hand-thumbs-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-handbag-fill' />
          <div className='label'>handbag-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-handbag' />
          <div className='label'>handbag</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hash' />
          <div className='label'>hash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hdd-fill' />
          <div className='label'>hdd-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hdd-network-fill' />
          <div className='label'>hdd-network-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hdd-network' />
          <div className='label'>hdd-network</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hdd-rack-fill' />
          <div className='label'>hdd-rack-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hdd-rack' />
          <div className='label'>hdd-rack</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hdd-stack-fill' />
          <div className='label'>hdd-stack-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hdd-stack' />
          <div className='label'>hdd-stack</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hdd' />
          <div className='label'>hdd</div>
        </div>
        <div className='icon'>
          <i className='bi bi-headphones' />
          <div className='label'>headphones</div>
        </div>
        <div className='icon'>
          <i className='bi bi-headset-vr' />
          <div className='label'>headset-vr</div>
        </div>
        <div className='icon'>
          <i className='bi bi-headset' />
          <div className='label'>headset</div>
        </div>
        <div className='icon'>
          <i className='bi bi-heart-fill' />
          <div className='label'>heart-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-heart-half' />
          <div className='label'>heart-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-heart' />
          <div className='label'>heart</div>
        </div>
        <div className='icon'>
          <i className='bi bi-heptagon-fill' />
          <div className='label'>heptagon-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-heptagon-half' />
          <div className='label'>heptagon-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-heptagon' />
          <div className='label'>heptagon</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hexagon-fill' />
          <div className='label'>hexagon-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hexagon-half' />
          <div className='label'>hexagon-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hexagon' />
          <div className='label'>hexagon</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hourglass-bottom' />
          <div className='label'>hourglass-bottom</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hourglass-split' />
          <div className='label'>hourglass-split</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hourglass-top' />
          <div className='label'>hourglass-top</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hourglass' />
          <div className='label'>hourglass</div>
        </div>
        <div className='icon'>
          <i className='bi bi-house-door-fill' />
          <div className='label'>house-door-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-house-door' />
          <div className='label'>house-door</div>
        </div>
        <div className='icon'>
          <i className='bi bi-house-fill' />
          <div className='label'>house-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-house' />
          <div className='label'>house</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hr' />
          <div className='label'>hr</div>
        </div>
        <div className='icon'>
          <i className='bi bi-hurricane' />
          <div className='label'>hurricane</div>
        </div>
        <div className='icon'>
          <i className='bi bi-image-alt' />
          <div className='label'>image-alt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-image-fill' />
          <div className='label'>image-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-image' />
          <div className='label'>image</div>
        </div>
        <div className='icon'>
          <i className='bi bi-images' />
          <div className='label'>images</div>
        </div>
        <div className='icon'>
          <i className='bi bi-inbox-fill' />
          <div className='label'>inbox-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-inbox' />
          <div className='label'>inbox</div>
        </div>
        <div className='icon'>
          <i className='bi bi-inboxes-fill' />
          <div className='label'>inboxes-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-inboxes' />
          <div className='label'>inboxes</div>
        </div>
        <div className='icon'>
          <i className='bi bi-info-circle-fill' />
          <div className='label'>info-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-info-circle' />
          <div className='label'>info-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-info-lg' />
          <div className='label'>info-lg</div>
        </div>
        <div className='icon'>
          <i className='bi bi-info-square-fill' />
          <div className='label'>info-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-info-square' />
          <div className='label'>info-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-info' />
          <div className='label'>info</div>
        </div>
        <div className='icon'>
          <i className='bi bi-input-cursor-text' />
          <div className='label'>input-cursor-text</div>
        </div>
        <div className='icon'>
          <i className='bi bi-input-cursor' />
          <div className='label'>input-cursor</div>
        </div>
        <div className='icon'>
          <i className='bi bi-instagram' />
          <div className='label'>instagram</div>
        </div>
        <div className='icon'>
          <i className='bi bi-intersect' />
          <div className='label'>intersect</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-album' />
          <div className='label'>journal-album</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-arrow-down' />
          <div className='label'>journal-arrow-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-arrow-up' />
          <div className='label'>journal-arrow-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-bookmark-fill' />
          <div className='label'>journal-bookmark-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-bookmark' />
          <div className='label'>journal-bookmark</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-check' />
          <div className='label'>journal-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-code' />
          <div className='label'>journal-code</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-medical' />
          <div className='label'>journal-medical</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-minus' />
          <div className='label'>journal-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-plus' />
          <div className='label'>journal-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-richtext' />
          <div className='label'>journal-richtext</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-text' />
          <div className='label'>journal-text</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal-x' />
          <div className='label'>journal-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journal' />
          <div className='label'>journal</div>
        </div>
        <div className='icon'>
          <i className='bi bi-journals' />
          <div className='label'>journals</div>
        </div>
        <div className='icon'>
          <i className='bi bi-joystick' />
          <div className='label'>joystick</div>
        </div>
        <div className='icon'>
          <i className='bi bi-justify-left' />
          <div className='label'>justify-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-justify-right' />
          <div className='label'>justify-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-justify' />
          <div className='label'>justify</div>
        </div>
        <div className='icon'>
          <i className='bi bi-kanban-fill' />
          <div className='label'>kanban-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-kanban' />
          <div className='label'>kanban</div>
        </div>
        <div className='icon'>
          <i className='bi bi-key-fill' />
          <div className='label'>key-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-key' />
          <div className='label'>key</div>
        </div>
        <div className='icon'>
          <i className='bi bi-keyboard-fill' />
          <div className='label'>keyboard-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-keyboard' />
          <div className='label'>keyboard</div>
        </div>
        <div className='icon'>
          <i className='bi bi-ladder' />
          <div className='label'>ladder</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lamp-fill' />
          <div className='label'>lamp-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lamp' />
          <div className='label'>lamp</div>
        </div>
        <div className='icon'>
          <i className='bi bi-laptop-fill' />
          <div className='label'>laptop-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-laptop' />
          <div className='label'>laptop</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layer-backward' />
          <div className='label'>layer-backward</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layer-forward' />
          <div className='label'>layer-forward</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layers-fill' />
          <div className='label'>layers-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layers-half' />
          <div className='label'>layers-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layers' />
          <div className='label'>layers</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-sidebar-inset-reverse' />
          <div className='label'>layout-sidebar-inset-reverse</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-sidebar-inset' />
          <div className='label'>layout-sidebar-inset</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-sidebar-reverse' />
          <div className='label'>layout-sidebar-reverse</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-sidebar' />
          <div className='label'>layout-sidebar</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-split' />
          <div className='label'>layout-split</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-text-sidebar-reverse' />
          <div className='label'>layout-text-sidebar-reverse</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-text-sidebar' />
          <div className='label'>layout-text-sidebar</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-text-window-reverse' />
          <div className='label'>layout-text-window-reverse</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-text-window' />
          <div className='label'>layout-text-window</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-three-columns' />
          <div className='label'>layout-three-columns</div>
        </div>
        <div className='icon'>
          <i className='bi bi-layout-wtf' />
          <div className='label'>layout-wtf</div>
        </div>
        <div className='icon'>
          <i className='bi bi-life-preserver' />
          <div className='label'>life-preserver</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lightbulb-fill' />
          <div className='label'>lightbulb-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lightbulb-off-fill' />
          <div className='label'>lightbulb-off-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lightbulb-off' />
          <div className='label'>lightbulb-off</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lightbulb' />
          <div className='label'>lightbulb</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lightning-charge-fill' />
          <div className='label'>lightning-charge-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lightning-charge' />
          <div className='label'>lightning-charge</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lightning-fill' />
          <div className='label'>lightning-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lightning' />
          <div className='label'>lightning</div>
        </div>
        <div className='icon'>
          <i className='bi bi-link-45deg' />
          <div className='label'>link-45deg</div>
        </div>
        <div className='icon'>
          <i className='bi bi-link' />
          <div className='label'>link</div>
        </div>
        <div className='icon'>
          <i className='bi bi-linkedin' />
          <div className='label'>linkedin</div>
        </div>
        <div className='icon'>
          <i className='bi bi-list-check' />
          <div className='label'>list-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-list-nested' />
          <div className='label'>list-nested</div>
        </div>
        <div className='icon'>
          <i className='bi bi-list-ol' />
          <div className='label'>list-ol</div>
        </div>
        <div className='icon'>
          <i className='bi bi-list-stars' />
          <div className='label'>list-stars</div>
        </div>
        <div className='icon'>
          <i className='bi bi-list-task' />
          <div className='label'>list-task</div>
        </div>
        <div className='icon'>
          <i className='bi bi-list-ul' />
          <div className='label'>list-ul</div>
        </div>
        <div className='icon'>
          <i className='bi bi-list' />
          <div className='label'>list</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lock-fill' />
          <div className='label'>lock-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-lock' />
          <div className='label'>lock</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mailbox' />
          <div className='label'>mailbox</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mailbox2' />
          <div className='label'>mailbox2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-map-fill' />
          <div className='label'>map-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-map' />
          <div className='label'>map</div>
        </div>
        <div className='icon'>
          <i className='bi bi-markdown-fill' />
          <div className='label'>markdown-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-markdown' />
          <div className='label'>markdown</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mask' />
          <div className='label'>mask</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mastodon' />
          <div className='label'>mastodon</div>
        </div>
        <div className='icon'>
          <i className='bi bi-megaphone-fill' />
          <div className='label'>megaphone-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-megaphone' />
          <div className='label'>megaphone</div>
        </div>
        <div className='icon'>
          <i className='bi bi-menu-app-fill' />
          <div className='label'>menu-app-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-menu-app' />
          <div className='label'>menu-app</div>
        </div>
        <div className='icon'>
          <i className='bi bi-menu-button-fill' />
          <div className='label'>menu-button-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-menu-button-wide-fill' />
          <div className='label'>menu-button-wide-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-menu-button-wide' />
          <div className='label'>menu-button-wide</div>
        </div>
        <div className='icon'>
          <i className='bi bi-menu-button' />
          <div className='label'>menu-button</div>
        </div>
        <div className='icon'>
          <i className='bi bi-menu-down' />
          <div className='label'>menu-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-menu-up' />
          <div className='label'>menu-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-messenger' />
          <div className='label'>messenger</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mic-fill' />
          <div className='label'>mic-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mic-mute-fill' />
          <div className='label'>mic-mute-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mic-mute' />
          <div className='label'>mic-mute</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mic' />
          <div className='label'>mic</div>
        </div>
        <div className='icon'>
          <i className='bi bi-minecart-loaded' />
          <div className='label'>minecart-loaded</div>
        </div>
        <div className='icon'>
          <i className='bi bi-minecart' />
          <div className='label'>minecart</div>
        </div>
        <div className='icon'>
          <i className='bi bi-moisture' />
          <div className='label'>moisture</div>
        </div>
        <div className='icon'>
          <i className='bi bi-moon-fill' />
          <div className='label'>moon-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-moon-stars-fill' />
          <div className='label'>moon-stars-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-moon-stars' />
          <div className='label'>moon-stars</div>
        </div>
        <div className='icon'>
          <i className='bi bi-moon' />
          <div className='label'>moon</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mouse-fill' />
          <div className='label'>mouse-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mouse' />
          <div className='label'>mouse</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mouse2-fill' />
          <div className='label'>mouse2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mouse2' />
          <div className='label'>mouse2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mouse3-fill' />
          <div className='label'>mouse3-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-mouse3' />
          <div className='label'>mouse3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-music-note-beamed' />
          <div className='label'>music-note-beamed</div>
        </div>
        <div className='icon'>
          <i className='bi bi-music-note-list' />
          <div className='label'>music-note-list</div>
        </div>
        <div className='icon'>
          <i className='bi bi-music-note' />
          <div className='label'>music-note</div>
        </div>
        <div className='icon'>
          <i className='bi bi-music-player-fill' />
          <div className='label'>music-player-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-music-player' />
          <div className='label'>music-player</div>
        </div>
        <div className='icon'>
          <i className='bi bi-newspaper' />
          <div className='label'>newspaper</div>
        </div>
        <div className='icon'>
          <i className='bi bi-node-minus-fill' />
          <div className='label'>node-minus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-node-minus' />
          <div className='label'>node-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-node-plus-fill' />
          <div className='label'>node-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-node-plus' />
          <div className='label'>node-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-nut-fill' />
          <div className='label'>nut-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-nut' />
          <div className='label'>nut</div>
        </div>
        <div className='icon'>
          <i className='bi bi-octagon-fill' />
          <div className='label'>octagon-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-octagon-half' />
          <div className='label'>octagon-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-octagon' />
          <div className='label'>octagon</div>
        </div>
        <div className='icon'>
          <i className='bi bi-option' />
          <div className='label'>option</div>
        </div>
        <div className='icon'>
          <i className='bi bi-outlet' />
          <div className='label'>outlet</div>
        </div>
        <div className='icon'>
          <i className='bi bi-paint-bucket' />
          <div className='label'>paint-bucket</div>
        </div>
        <div className='icon'>
          <i className='bi bi-palette-fill' />
          <div className='label'>palette-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-palette' />
          <div className='label'>palette</div>
        </div>
        <div className='icon'>
          <i className='bi bi-palette2' />
          <div className='label'>palette2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-paperclip' />
          <div className='label'>paperclip</div>
        </div>
        <div className='icon'>
          <i className='bi bi-paragraph' />
          <div className='label'>paragraph</div>
        </div>
        <div className='icon'>
          <i className='bi bi-patch-check-fill' />
          <div className='label'>patch-check-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-patch-check' />
          <div className='label'>patch-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-patch-exclamation-fill' />
          <div className='label'>patch-exclamation-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-patch-exclamation' />
          <div className='label'>patch-exclamation</div>
        </div>
        <div className='icon'>
          <i className='bi bi-patch-minus-fill' />
          <div className='label'>patch-minus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-patch-minus' />
          <div className='label'>patch-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-patch-plus-fill' />
          <div className='label'>patch-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-patch-plus' />
          <div className='label'>patch-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-patch-question-fill' />
          <div className='label'>patch-question-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-patch-question' />
          <div className='label'>patch-question</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pause-btn-fill' />
          <div className='label'>pause-btn-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pause-btn' />
          <div className='label'>pause-btn</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pause-circle-fill' />
          <div className='label'>pause-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pause-circle' />
          <div className='label'>pause-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pause-fill' />
          <div className='label'>pause-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pause' />
          <div className='label'>pause</div>
        </div>
        <div className='icon'>
          <i className='bi bi-peace-fill' />
          <div className='label'>peace-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-peace' />
          <div className='label'>peace</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pen-fill' />
          <div className='label'>pen-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pen' />
          <div className='label'>pen</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pencil-fill' />
          <div className='label'>pencil-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pencil-square' />
          <div className='label'>pencil-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pencil' />
          <div className='label'>pencil</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pentagon-fill' />
          <div className='label'>pentagon-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pentagon-half' />
          <div className='label'>pentagon-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pentagon' />
          <div className='label'>pentagon</div>
        </div>
        <div className='icon'>
          <i className='bi bi-people-fill' />
          <div className='label'>people-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-people' />
          <div className='label'>people</div>
        </div>
        <div className='icon'>
          <i className='bi bi-percent' />
          <div className='label'>percent</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-badge-fill' />
          <div className='label'>person-badge-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-badge' />
          <div className='label'>person-badge</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-bounding-box' />
          <div className='label'>person-bounding-box</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-check-fill' />
          <div className='label'>person-check-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-check' />
          <div className='label'>person-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-circle' />
          <div className='label'>person-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-dash-fill' />
          <div className='label'>person-dash-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-dash' />
          <div className='label'>person-dash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-fill' />
          <div className='label'>person-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-lines-fill' />
          <div className='label'>person-lines-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-plus-fill' />
          <div className='label'>person-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-plus' />
          <div className='label'>person-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-square' />
          <div className='label'>person-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-x-fill' />
          <div className='label'>person-x-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person-x' />
          <div className='label'>person-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-person' />
          <div className='label'>person</div>
        </div>
        <div className='icon'>
          <i className='bi bi-phone-fill' />
          <div className='label'>phone-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-phone-landscape-fill' />
          <div className='label'>phone-landscape-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-phone-landscape' />
          <div className='label'>phone-landscape</div>
        </div>
        <div className='icon'>
          <i className='bi bi-phone-vibrate-fill' />
          <div className='label'>phone-vibrate-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-phone-vibrate' />
          <div className='label'>phone-vibrate</div>
        </div>
        <div className='icon'>
          <i className='bi bi-phone' />
          <div className='label'>phone</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pie-chart-fill' />
          <div className='label'>pie-chart-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pie-chart' />
          <div className='label'>pie-chart</div>
        </div>
        <div className='icon'>
          <i className='bi bi-piggy-bank-fill' />
          <div className='label'>piggy-bank-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-piggy-bank' />
          <div className='label'>piggy-bank</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pin-angle-fill' />
          <div className='label'>pin-angle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pin-angle' />
          <div className='label'>pin-angle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pin-fill' />
          <div className='label'>pin-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pin-map-fill' />
          <div className='label'>pin-map-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pin-map' />
          <div className='label'>pin-map</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pin' />
          <div className='label'>pin</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pip-fill' />
          <div className='label'>pip-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-pip' />
          <div className='label'>pip</div>
        </div>
        <div className='icon'>
          <i className='bi bi-play-btn-fill' />
          <div className='label'>play-btn-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-play-btn' />
          <div className='label'>play-btn</div>
        </div>
        <div className='icon'>
          <i className='bi bi-play-circle-fill' />
          <div className='label'>play-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-play-circle' />
          <div className='label'>play-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-play-fill' />
          <div className='label'>play-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-play' />
          <div className='label'>play</div>
        </div>
        <div className='icon'>
          <i className='bi bi-plug-fill' />
          <div className='label'>plug-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-plug' />
          <div className='label'>plug</div>
        </div>
        <div className='icon'>
          <i className='bi bi-plus-circle-dotted' />
          <div className='label'>plus-circle-dotted</div>
        </div>
        <div className='icon'>
          <i className='bi bi-plus-circle-fill' />
          <div className='label'>plus-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-plus-circle' />
          <div className='label'>plus-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-plus-lg' />
          <div className='label'>plus-lg</div>
        </div>
        <div className='icon'>
          <i className='bi bi-plus-square-dotted' />
          <div className='label'>plus-square-dotted</div>
        </div>
        <div className='icon'>
          <i className='bi bi-plus-square-fill' />
          <div className='label'>plus-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-plus-square' />
          <div className='label'>plus-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-plus' />
          <div className='label'>plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-power' />
          <div className='label'>power</div>
        </div>
        <div className='icon'>
          <i className='bi bi-printer-fill' />
          <div className='label'>printer-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-printer' />
          <div className='label'>printer</div>
        </div>
        <div className='icon'>
          <i className='bi bi-puzzle-fill' />
          <div className='label'>puzzle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-puzzle' />
          <div className='label'>puzzle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-question-circle-fill' />
          <div className='label'>question-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-question-circle' />
          <div className='label'>question-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-question-diamond-fill' />
          <div className='label'>question-diamond-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-question-diamond' />
          <div className='label'>question-diamond</div>
        </div>
        <div className='icon'>
          <i className='bi bi-question-lg' />
          <div className='label'>question-lg</div>
        </div>
        <div className='icon'>
          <i className='bi bi-question-octagon-fill' />
          <div className='label'>question-octagon-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-question-octagon' />
          <div className='label'>question-octagon</div>
        </div>
        <div className='icon'>
          <i className='bi bi-question-square-fill' />
          <div className='label'>question-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-question-square' />
          <div className='label'>question-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-question' />
          <div className='label'>question</div>
        </div>
        <div className='icon'>
          <i className='bi bi-rainbow' />
          <div className='label'>rainbow</div>
        </div>
        <div className='icon'>
          <i className='bi bi-receipt-cutoff' />
          <div className='label'>receipt-cutoff</div>
        </div>
        <div className='icon'>
          <i className='bi bi-receipt' />
          <div className='label'>receipt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-reception-0' />
          <div className='label'>reception-0</div>
        </div>
        <div className='icon'>
          <i className='bi bi-reception-1' />
          <div className='label'>reception-1</div>
        </div>
        <div className='icon'>
          <i className='bi bi-reception-2' />
          <div className='label'>reception-2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-reception-3' />
          <div className='label'>reception-3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-reception-4' />
          <div className='label'>reception-4</div>
        </div>
        <div className='icon'>
          <i className='bi bi-record-btn-fill' />
          <div className='label'>record-btn-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-record-btn' />
          <div className='label'>record-btn</div>
        </div>
        <div className='icon'>
          <i className='bi bi-record-circle-fill' />
          <div className='label'>record-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-record-circle' />
          <div className='label'>record-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-record-fill' />
          <div className='label'>record-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-record' />
          <div className='label'>record</div>
        </div>
        <div className='icon'>
          <i className='bi bi-record2-fill' />
          <div className='label'>record2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-record2' />
          <div className='label'>record2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-recycle' />
          <div className='label'>recycle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-reddit' />
          <div className='label'>reddit</div>
        </div>
        <div className='icon'>
          <i className='bi bi-reply-all-fill' />
          <div className='label'>reply-all-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-reply-all' />
          <div className='label'>reply-all</div>
        </div>
        <div className='icon'>
          <i className='bi bi-reply-fill' />
          <div className='label'>reply-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-reply' />
          <div className='label'>reply</div>
        </div>
        <div className='icon'>
          <i className='bi bi-rss-fill' />
          <div className='label'>rss-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-rss' />
          <div className='label'>rss</div>
        </div>
        <div className='icon'>
          <i className='bi bi-rulers' />
          <div className='label'>rulers</div>
        </div>
        <div className='icon'>
          <i className='bi bi-safe-fill' />
          <div className='label'>safe-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-safe' />
          <div className='label'>safe</div>
        </div>
        <div className='icon'>
          <i className='bi bi-safe2-fill' />
          <div className='label'>safe2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-safe2' />
          <div className='label'>safe2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-save-fill' />
          <div className='label'>save-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-save' />
          <div className='label'>save</div>
        </div>
        <div className='icon'>
          <i className='bi bi-save2-fill' />
          <div className='label'>save2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-save2' />
          <div className='label'>save2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-scissors' />
          <div className='label'>scissors</div>
        </div>
        <div className='icon'>
          <i className='bi bi-screwdriver' />
          <div className='label'>screwdriver</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sd-card-fill' />
          <div className='label'>sd-card-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sd-card' />
          <div className='label'>sd-card</div>
        </div>
        <div className='icon'>
          <i className='bi bi-search' />
          <div className='label'>search</div>
        </div>
        <div className='icon'>
          <i className='bi bi-segmented-nav' />
          <div className='label'>segmented-nav</div>
        </div>
        <div className='icon'>
          <i className='bi bi-server' />
          <div className='label'>server</div>
        </div>
        <div className='icon'>
          <i className='bi bi-share-fill' />
          <div className='label'>share-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-share' />
          <div className='label'>share</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-check' />
          <div className='label'>shield-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-exclamation' />
          <div className='label'>shield-exclamation</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-fill-check' />
          <div className='label'>shield-fill-check</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-fill-exclamation' />
          <div className='label'>shield-fill-exclamation</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-fill-minus' />
          <div className='label'>shield-fill-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-fill-plus' />
          <div className='label'>shield-fill-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-fill-x' />
          <div className='label'>shield-fill-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-fill' />
          <div className='label'>shield-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-lock-fill' />
          <div className='label'>shield-lock-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-lock' />
          <div className='label'>shield-lock</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-minus' />
          <div className='label'>shield-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-plus' />
          <div className='label'>shield-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-shaded' />
          <div className='label'>shield-shaded</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-slash-fill' />
          <div className='label'>shield-slash-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-slash' />
          <div className='label'>shield-slash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield-x' />
          <div className='label'>shield-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shield' />
          <div className='label'>shield</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shift-fill' />
          <div className='label'>shift-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shift' />
          <div className='label'>shift</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shop-window' />
          <div className='label'>shop-window</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shop' />
          <div className='label'>shop</div>
        </div>
        <div className='icon'>
          <i className='bi bi-shuffle' />
          <div className='label'>shuffle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-signpost-2-fill' />
          <div className='label'>signpost-2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-signpost-2' />
          <div className='label'>signpost-2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-signpost-fill' />
          <div className='label'>signpost-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-signpost-split-fill' />
          <div className='label'>signpost-split-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-signpost-split' />
          <div className='label'>signpost-split</div>
        </div>
        <div className='icon'>
          <i className='bi bi-signpost' />
          <div className='label'>signpost</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sim-fill' />
          <div className='label'>sim-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sim' />
          <div className='label'>sim</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-backward-btn-fill' />
          <div className='label'>skip-backward-btn-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-backward-btn' />
          <div className='label'>skip-backward-btn</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-backward-circle-fill' />
          <div className='label'>skip-backward-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-backward-circle' />
          <div className='label'>skip-backward-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-backward-fill' />
          <div className='label'>skip-backward-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-backward' />
          <div className='label'>skip-backward</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-end-btn-fill' />
          <div className='label'>skip-end-btn-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-end-btn' />
          <div className='label'>skip-end-btn</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-end-circle-fill' />
          <div className='label'>skip-end-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-end-circle' />
          <div className='label'>skip-end-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-end-fill' />
          <div className='label'>skip-end-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-end' />
          <div className='label'>skip-end</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-forward-btn-fill' />
          <div className='label'>skip-forward-btn-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-forward-btn' />
          <div className='label'>skip-forward-btn</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-forward-circle-fill' />
          <div className='label'>skip-forward-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-forward-circle' />
          <div className='label'>skip-forward-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-forward-fill' />
          <div className='label'>skip-forward-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-forward' />
          <div className='label'>skip-forward</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-start-btn-fill' />
          <div className='label'>skip-start-btn-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-start-btn' />
          <div className='label'>skip-start-btn</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-start-circle-fill' />
          <div className='label'>skip-start-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-start-circle' />
          <div className='label'>skip-start-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-start-fill' />
          <div className='label'>skip-start-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skip-start' />
          <div className='label'>skip-start</div>
        </div>
        <div className='icon'>
          <i className='bi bi-skype' />
          <div className='label'>skype</div>
        </div>
        <div className='icon'>
          <i className='bi bi-slack' />
          <div className='label'>slack</div>
        </div>
        <div className='icon'>
          <i className='bi bi-slash-circle-fill' />
          <div className='label'>slash-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-slash-circle' />
          <div className='label'>slash-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-slash-lg' />
          <div className='label'>slash-lg</div>
        </div>
        <div className='icon'>
          <i className='bi bi-slash-square-fill' />
          <div className='label'>slash-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-slash-square' />
          <div className='label'>slash-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-slash' />
          <div className='label'>slash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sliders' />
          <div className='label'>sliders</div>
        </div>
        <div className='icon'>
          <i className='bi bi-smartwatch' />
          <div className='label'>smartwatch</div>
        </div>
        <div className='icon'>
          <i className='bi bi-snow' />
          <div className='label'>snow</div>
        </div>
        <div className='icon'>
          <i className='bi bi-snow2' />
          <div className='label'>snow2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-snow3' />
          <div className='label'>snow3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-alpha-down-alt' />
          <div className='label'>sort-alpha-down-alt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-alpha-down' />
          <div className='label'>sort-alpha-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-alpha-up-alt' />
          <div className='label'>sort-alpha-up-alt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-alpha-up' />
          <div className='label'>sort-alpha-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-down-alt' />
          <div className='label'>sort-down-alt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-down' />
          <div className='label'>sort-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-numeric-down-alt' />
          <div className='label'>sort-numeric-down-alt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-numeric-down' />
          <div className='label'>sort-numeric-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-numeric-up-alt' />
          <div className='label'>sort-numeric-up-alt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-numeric-up' />
          <div className='label'>sort-numeric-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-up-alt' />
          <div className='label'>sort-up-alt</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sort-up' />
          <div className='label'>sort-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-soundwave' />
          <div className='label'>soundwave</div>
        </div>
        <div className='icon'>
          <i className='bi bi-speaker-fill' />
          <div className='label'>speaker-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-speaker' />
          <div className='label'>speaker</div>
        </div>
        <div className='icon'>
          <i className='bi bi-speedometer' />
          <div className='label'>speedometer</div>
        </div>
        <div className='icon'>
          <i className='bi bi-speedometer2' />
          <div className='label'>speedometer2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-spellcheck' />
          <div className='label'>spellcheck</div>
        </div>
        <div className='icon'>
          <i className='bi bi-square-fill' />
          <div className='label'>square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-square-half' />
          <div className='label'>square-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-square' />
          <div className='label'>square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stack' />
          <div className='label'>stack</div>
        </div>
        <div className='icon'>
          <i className='bi bi-star-fill' />
          <div className='label'>star-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-star-half' />
          <div className='label'>star-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-star' />
          <div className='label'>star</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stars' />
          <div className='label'>stars</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stickies-fill' />
          <div className='label'>stickies-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stickies' />
          <div className='label'>stickies</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sticky-fill' />
          <div className='label'>sticky-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sticky' />
          <div className='label'>sticky</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stop-btn-fill' />
          <div className='label'>stop-btn-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stop-btn' />
          <div className='label'>stop-btn</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stop-circle-fill' />
          <div className='label'>stop-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stop-circle' />
          <div className='label'>stop-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stop-fill' />
          <div className='label'>stop-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stop' />
          <div className='label'>stop</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stoplights-fill' />
          <div className='label'>stoplights-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stoplights' />
          <div className='label'>stoplights</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stopwatch-fill' />
          <div className='label'>stopwatch-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-stopwatch' />
          <div className='label'>stopwatch</div>
        </div>
        <div className='icon'>
          <i className='bi bi-subtract' />
          <div className='label'>subtract</div>
        </div>
        <div className='icon'>
          <i className='bi bi-suit-club-fill' />
          <div className='label'>suit-club-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-suit-club' />
          <div className='label'>suit-club</div>
        </div>
        <div className='icon'>
          <i className='bi bi-suit-diamond-fill' />
          <div className='label'>suit-diamond-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-suit-diamond' />
          <div className='label'>suit-diamond</div>
        </div>
        <div className='icon'>
          <i className='bi bi-suit-heart-fill' />
          <div className='label'>suit-heart-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-suit-heart' />
          <div className='label'>suit-heart</div>
        </div>
        <div className='icon'>
          <i className='bi bi-suit-spade-fill' />
          <div className='label'>suit-spade-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-suit-spade' />
          <div className='label'>suit-spade</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sun-fill' />
          <div className='label'>sun-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sun' />
          <div className='label'>sun</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sunglasses' />
          <div className='label'>sunglasses</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sunrise-fill' />
          <div className='label'>sunrise-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sunrise' />
          <div className='label'>sunrise</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sunset-fill' />
          <div className='label'>sunset-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-sunset' />
          <div className='label'>sunset</div>
        </div>
        <div className='icon'>
          <i className='bi bi-symmetry-horizontal' />
          <div className='label'>symmetry-horizontal</div>
        </div>
        <div className='icon'>
          <i className='bi bi-symmetry-vertical' />
          <div className='label'>symmetry-vertical</div>
        </div>
        <div className='icon'>
          <i className='bi bi-table' />
          <div className='label'>table</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tablet-fill' />
          <div className='label'>tablet-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tablet-landscape-fill' />
          <div className='label'>tablet-landscape-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tablet-landscape' />
          <div className='label'>tablet-landscape</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tablet' />
          <div className='label'>tablet</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tag-fill' />
          <div className='label'>tag-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tag' />
          <div className='label'>tag</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tags-fill' />
          <div className='label'>tags-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tags' />
          <div className='label'>tags</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telegram' />
          <div className='label'>telegram</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-fill' />
          <div className='label'>telephone-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-forward-fill' />
          <div className='label'>telephone-forward-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-forward' />
          <div className='label'>telephone-forward</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-inbound-fill' />
          <div className='label'>telephone-inbound-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-inbound' />
          <div className='label'>telephone-inbound</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-minus-fill' />
          <div className='label'>telephone-minus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-minus' />
          <div className='label'>telephone-minus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-outbound-fill' />
          <div className='label'>telephone-outbound-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-outbound' />
          <div className='label'>telephone-outbound</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-plus-fill' />
          <div className='label'>telephone-plus-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-plus' />
          <div className='label'>telephone-plus</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-x-fill' />
          <div className='label'>telephone-x-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone-x' />
          <div className='label'>telephone-x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-telephone' />
          <div className='label'>telephone</div>
        </div>
        <div className='icon'>
          <i className='bi bi-terminal-fill' />
          <div className='label'>terminal-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-terminal' />
          <div className='label'>terminal</div>
        </div>
        <div className='icon'>
          <i className='bi bi-text-center' />
          <div className='label'>text-center</div>
        </div>
        <div className='icon'>
          <i className='bi bi-text-indent-left' />
          <div className='label'>text-indent-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-text-indent-right' />
          <div className='label'>text-indent-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-text-left' />
          <div className='label'>text-left</div>
        </div>
        <div className='icon'>
          <i className='bi bi-text-paragraph' />
          <div className='label'>text-paragraph</div>
        </div>
        <div className='icon'>
          <i className='bi bi-text-right' />
          <div className='label'>text-right</div>
        </div>
        <div className='icon'>
          <i className='bi bi-textarea-resize' />
          <div className='label'>textarea-resize</div>
        </div>
        <div className='icon'>
          <i className='bi bi-textarea-t' />
          <div className='label'>textarea-t</div>
        </div>
        <div className='icon'>
          <i className='bi bi-textarea' />
          <div className='label'>textarea</div>
        </div>
        <div className='icon'>
          <i className='bi bi-thermometer-half' />
          <div className='label'>thermometer-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-thermometer-high' />
          <div className='label'>thermometer-high</div>
        </div>
        <div className='icon'>
          <i className='bi bi-thermometer-low' />
          <div className='label'>thermometer-low</div>
        </div>
        <div className='icon'>
          <i className='bi bi-thermometer-snow' />
          <div className='label'>thermometer-snow</div>
        </div>
        <div className='icon'>
          <i className='bi bi-thermometer-sun' />
          <div className='label'>thermometer-sun</div>
        </div>
        <div className='icon'>
          <i className='bi bi-thermometer' />
          <div className='label'>thermometer</div>
        </div>
        <div className='icon'>
          <i className='bi bi-three-dots-vertical' />
          <div className='label'>three-dots-vertical</div>
        </div>
        <div className='icon'>
          <i className='bi bi-three-dots' />
          <div className='label'>three-dots</div>
        </div>
        <div className='icon'>
          <i className='bi bi-toggle-off' />
          <div className='label'>toggle-off</div>
        </div>
        <div className='icon'>
          <i className='bi bi-toggle-on' />
          <div className='label'>toggle-on</div>
        </div>
        <div className='icon'>
          <i className='bi bi-toggle2-off' />
          <div className='label'>toggle2-off</div>
        </div>
        <div className='icon'>
          <i className='bi bi-toggle2-on' />
          <div className='label'>toggle2-on</div>
        </div>
        <div className='icon'>
          <i className='bi bi-toggles' />
          <div className='label'>toggles</div>
        </div>
        <div className='icon'>
          <i className='bi bi-toggles2' />
          <div className='label'>toggles2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tools' />
          <div className='label'>tools</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tornado' />
          <div className='label'>tornado</div>
        </div>
        <div className='icon'>
          <i className='bi bi-translate' />
          <div className='label'>translate</div>
        </div>
        <div className='icon'>
          <i className='bi bi-trash-fill' />
          <div className='label'>trash-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-trash' />
          <div className='label'>trash</div>
        </div>
        <div className='icon'>
          <i className='bi bi-trash2-fill' />
          <div className='label'>trash2-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-trash2' />
          <div className='label'>trash2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tree-fill' />
          <div className='label'>tree-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tree' />
          <div className='label'>tree</div>
        </div>
        <div className='icon'>
          <i className='bi bi-triangle-fill' />
          <div className='label'>triangle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-triangle-half' />
          <div className='label'>triangle-half</div>
        </div>
        <div className='icon'>
          <i className='bi bi-triangle' />
          <div className='label'>triangle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-trophy-fill' />
          <div className='label'>trophy-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-trophy' />
          <div className='label'>trophy</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tropical-storm' />
          <div className='label'>tropical-storm</div>
        </div>
        <div className='icon'>
          <i className='bi bi-truck-flatbed' />
          <div className='label'>truck-flatbed</div>
        </div>
        <div className='icon'>
          <i className='bi bi-truck' />
          <div className='label'>truck</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tsunami' />
          <div className='label'>tsunami</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tv-fill' />
          <div className='label'>tv-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-tv' />
          <div className='label'>tv</div>
        </div>
        <div className='icon'>
          <i className='bi bi-twitch' />
          <div className='label'>twitch</div>
        </div>
        <div className='icon'>
          <i className='bi bi-twitter' />
          <div className='label'>twitter</div>
        </div>
        <div className='icon'>
          <i className='bi bi-type-bold' />
          <div className='label'>type-bold</div>
        </div>
        <div className='icon'>
          <i className='bi bi-type-h1' />
          <div className='label'>type-h1</div>
        </div>
        <div className='icon'>
          <i className='bi bi-type-h2' />
          <div className='label'>type-h2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-type-h3' />
          <div className='label'>type-h3</div>
        </div>
        <div className='icon'>
          <i className='bi bi-type-italic' />
          <div className='label'>type-italic</div>
        </div>
        <div className='icon'>
          <i className='bi bi-type-strikethrough' />
          <div className='label'>type-strikethrough</div>
        </div>
        <div className='icon'>
          <i className='bi bi-type-underline' />
          <div className='label'>type-underline</div>
        </div>
        <div className='icon'>
          <i className='bi bi-type' />
          <div className='label'>type</div>
        </div>
        <div className='icon'>
          <i className='bi bi-ui-checks-grid' />
          <div className='label'>ui-checks-grid</div>
        </div>
        <div className='icon'>
          <i className='bi bi-ui-checks' />
          <div className='label'>ui-checks</div>
        </div>
        <div className='icon'>
          <i className='bi bi-ui-radios-grid' />
          <div className='label'>ui-radios-grid</div>
        </div>
        <div className='icon'>
          <i className='bi bi-ui-radios' />
          <div className='label'>ui-radios</div>
        </div>
        <div className='icon'>
          <i className='bi bi-umbrella-fill' />
          <div className='label'>umbrella-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-umbrella' />
          <div className='label'>umbrella</div>
        </div>
        <div className='icon'>
          <i className='bi bi-union' />
          <div className='label'>union</div>
        </div>
        <div className='icon'>
          <i className='bi bi-unlock-fill' />
          <div className='label'>unlock-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-unlock' />
          <div className='label'>unlock</div>
        </div>
        <div className='icon'>
          <i className='bi bi-upc-scan' />
          <div className='label'>upc-scan</div>
        </div>
        <div className='icon'>
          <i className='bi bi-upc' />
          <div className='label'>upc</div>
        </div>
        <div className='icon'>
          <i className='bi bi-upload' />
          <div className='label'>upload</div>
        </div>
        <div className='icon'>
          <i className='bi bi-vector-pen' />
          <div className='label'>vector-pen</div>
        </div>
        <div className='icon'>
          <i className='bi bi-view-list' />
          <div className='label'>view-list</div>
        </div>
        <div className='icon'>
          <i className='bi bi-view-stacked' />
          <div className='label'>view-stacked</div>
        </div>
        <div className='icon'>
          <i className='bi bi-vinyl-fill' />
          <div className='label'>vinyl-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-vinyl' />
          <div className='label'>vinyl</div>
        </div>
        <div className='icon'>
          <i className='bi bi-voicemail' />
          <div className='label'>voicemail</div>
        </div>
        <div className='icon'>
          <i className='bi bi-volume-down-fill' />
          <div className='label'>volume-down-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-volume-down' />
          <div className='label'>volume-down</div>
        </div>
        <div className='icon'>
          <i className='bi bi-volume-mute-fill' />
          <div className='label'>volume-mute-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-volume-mute' />
          <div className='label'>volume-mute</div>
        </div>
        <div className='icon'>
          <i className='bi bi-volume-off-fill' />
          <div className='label'>volume-off-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-volume-off' />
          <div className='label'>volume-off</div>
        </div>
        <div className='icon'>
          <i className='bi bi-volume-up-fill' />
          <div className='label'>volume-up-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-volume-up' />
          <div className='label'>volume-up</div>
        </div>
        <div className='icon'>
          <i className='bi bi-vr' />
          <div className='label'>vr</div>
        </div>
        <div className='icon'>
          <i className='bi bi-wallet-fill' />
          <div className='label'>wallet-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-wallet' />
          <div className='label'>wallet</div>
        </div>
        <div className='icon'>
          <i className='bi bi-wallet2' />
          <div className='label'>wallet2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-watch' />
          <div className='label'>watch</div>
        </div>
        <div className='icon'>
          <i className='bi bi-water' />
          <div className='label'>water</div>
        </div>
        <div className='icon'>
          <i className='bi bi-whatsapp' />
          <div className='label'>whatsapp</div>
        </div>
        <div className='icon'>
          <i className='bi bi-wifi-1' />
          <div className='label'>wifi-1</div>
        </div>
        <div className='icon'>
          <i className='bi bi-wifi-2' />
          <div className='label'>wifi-2</div>
        </div>
        <div className='icon'>
          <i className='bi bi-wifi-off' />
          <div className='label'>wifi-off</div>
        </div>
        <div className='icon'>
          <i className='bi bi-wifi' />
          <div className='label'>wifi</div>
        </div>
        <div className='icon'>
          <i className='bi bi-wind' />
          <div className='label'>wind</div>
        </div>
        <div className='icon'>
          <i className='bi bi-window-dock' />
          <div className='label'>window-dock</div>
        </div>
        <div className='icon'>
          <i className='bi bi-window-sidebar' />
          <div className='label'>window-sidebar</div>
        </div>
        <div className='icon'>
          <i className='bi bi-window' />
          <div className='label'>window</div>
        </div>
        <div className='icon'>
          <i className='bi bi-wrench' />
          <div className='label'>wrench</div>
        </div>
        <div className='icon'>
          <i className='bi bi-x-circle-fill' />
          <div className='label'>x-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-x-circle' />
          <div className='label'>x-circle</div>
        </div>
        <div className='icon'>
          <i className='bi bi-x-diamond-fill' />
          <div className='label'>x-diamond-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-x-diamond' />
          <div className='label'>x-diamond</div>
        </div>
        <div className='icon'>
          <i className='bi bi-x-lg' />
          <div className='label'>x-lg</div>
        </div>
        <div className='icon'>
          <i className='bi bi-x-octagon-fill' />
          <div className='label'>x-octagon-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-x-octagon' />
          <div className='label'>x-octagon</div>
        </div>
        <div className='icon'>
          <i className='bi bi-x-square-fill' />
          <div className='label'>x-square-fill</div>
        </div>
        <div className='icon'>
          <i className='bi bi-x-square' />
          <div className='label'>x-square</div>
        </div>
        <div className='icon'>
          <i className='bi bi-x' />
          <div className='label'>x</div>
        </div>
        <div className='icon'>
          <i className='bi bi-youtube' />
          <div className='label'>youtube</div>
        </div>
        <div className='icon'>
          <i className='bi bi-zoom-in' />
          <div className='label'>zoom-in</div>
        </div>
        <div className='icon'>
          <i className='bi bi-zoom-out' />
          <div className='label'>zoom-out</div>
        </div>
      </div>
    </section>
  );
};

export default BootstrapIconsInner;
